export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;

const MAX_DIMENSION = 2000;
const SKIP_COMPRESSION_BYTES = 1.5 * 1024 * 1024;

// Downscale/re-encode large images client-side so uploads stay under proxy limits.
// If the browser can't decode the file (e.g. HEIC on Chrome), the original file
// is returned and the backend converts it instead.
export const compressImageFile = (file) =>
  new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new window.Image();

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      try {
        const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
        if (scale === 1 && file.size < SKIP_COMPRESSION_BYTES) {
          resolve(file);
          return;
        }

        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        const ctx = canvas.getContext('2d');

        const isJpeg = file.type === 'image/jpeg';
        if (isJpeg) {
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(file);
              return;
            }
            const baseName = (file.name || 'image').replace(/\.[^.]+$/, '');
            resolve(new File([blob], `${baseName}${isJpeg ? '.jpg' : '.png'}`, { type: blob.type }));
          },
          isJpeg ? 'image/jpeg' : 'image/png',
          0.92
        );
      } catch (err) {
        resolve(file);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file);
    };

    img.src = objectUrl;
  });
